import React from 'react';
import NewVSStep5 from './NewVSStep5';

const NewVSStep5Container = ({ formikProp, osData }) => {
  return <NewVSStep5 osData={osData} formikProp={formikProp} />;
};

export default NewVSStep5Container;
